import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "admin-info" }

import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { 
  Menu, 
  Fold, 
  Expand, 
  HomeFilled, 
  Picture, 
  Document, 
  User, 
  UserFilled,
  Promotion, 
  Wallet 
} from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const activeMenu = computed(() => route.path)

const pageTitleMap: Record<string, string> = {
  '/dashboard': '数据概览',
  '/banner': '轮播图管理',
  '/region': '地区管理',
  '/paper': '试卷管理',
  '/single-question': '单一题管理',
  '/standard-word': '规范词管理',
  '/user': '普通用户管理',
  '/admin': '管理员管理',
  '/vip-package': '会员套餐管理',
  '/coupon': '优惠券管理',
  '/invitation': '推广记录管理',
  '/consumption': '会员开通记录',
  '/profile': '个人中心',
  '/prompt-config': '提示词管理',
  '/my-page-option': '选项管理'
}

const pageTitle = computed(() => {
  // 处理动态路由的页面标题
  if (route.path.includes('/paper/') && route.path.includes('/questions')) {
    return '题目管理'
  }
  return pageTitleMap[route.path] || '管理后台'
})

const handleCommand = (command: string) => {
  if (command === 'logout') {
    ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      localStorage.removeItem('admin_token')
      router.push('/login')
      ElMessage.success('已退出登录')
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_DataLine = _resolveComponent("DataLine")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          width: "240px",
          class: "sidebar"
        }, {
          default: _withCtx(() => [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "logo" }, [
              _createElementVNode("h2", null, "考试练习平台"),
              _createElementVNode("p", null, "管理后台")
            ], -1)),
            _createVNode(_component_el_menu, {
              "default-active": activeMenu.value,
              router: "",
              class: "sidebar-menu"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "/dashboard" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DataLine)
                      ]),
                      _: 1
                    }),
                    _cache[0] || (_cache[0] = _createElementVNode("span", null, "数据概览", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/banner" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Picture))
                      ]),
                      _: 1
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "轮播图管理", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_sub_menu, { index: "content" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Document))
                      ]),
                      _: 1
                    }),
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "内容管理", -1))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "/region" }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("地区管理", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/paper" }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("试卷管理", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/single-question" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("单一题管理", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/standard-word" }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("规范词管理", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/my-page-option" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("选项管理", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/prompt-config" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("提示词管理", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_sub_menu, { index: "user" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(User))
                      ]),
                      _: 1
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "用户管理", -1))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "/user" }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("普通用户", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/admin" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("管理员", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_sub_menu, { index: "marketing" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Promotion))
                      ]),
                      _: 1
                    }),
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "营销管理", -1))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, { index: "/vip-package" }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("会员套餐", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/coupon" }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("优惠券管理", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/invitation" }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("邀请记录", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, { index: "/consumption" }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("消费记录", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "/profile" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserFilled))
                      ]),
                      _: 1
                    }),
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "个人中心", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["default-active"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h3", null, _toDisplayString(pageTitle.value), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_dropdown_item, { command: "logout" }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createTextVNode("退出登录", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Avatar)
                          ]),
                          _: 1
                        }),
                        _cache[19] || (_cache[19] = _createElementVNode("span", null, "管理员", -1))
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { class: "main-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})